import { ApolloClient, GQL_SEND_LOGS, Log } from '@sfstudios/shapeshifter';

export const apolloLog = (client: ApolloClient, logs: Log[]) =>
  client.mutate({
    mutation: GQL_SEND_LOGS,
    variables: {
      logs
    },
    context: { isLog: true },
    errorPolicy: 'ignore',
    fetchPolicy: 'no-cache'
  });
